// Origens, marcas, categorias e links são strings delimitadas por pipe ("A|B").
export interface CommercialSupplier {
  id?: string;
  name?: string;
  origins?: string | null;
  brands?: string | null;
  categories?: string | null;
  fileLinks?: string | null;
  paymentTerms?: string | null;
  email?: string | null;
  focalPoint?: string | null;
  containersInWater?: number | null;
  containersInProduction?: number | null;
  orderDate?: string | null;
  notes?: string | null;
  /** Tempo de produção (dias corridos): Backorder estima a prontidão. */
  productionDays?: number | null;
  createdDate?: string;
}

export const supplierCategories = ["PCR", "TBR", "OTR", "AGR", "INDUSTRIAL", "CONSTRUCTION", "UTILITÁRIOS"];

export const splitPipe = (value?: string | null): string[] =>
  value ? value.split("|").map((item) => item.trim()).filter(Boolean) : [];

export const joinPipe = (items: string[]): string | null => (items.length ? items.join("|") : null);
